<template>
  <section class="overlays_modal">
    <h4 class="text-center">Overlays</h4>
    <div class="overlays_table">
      <table>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column">
              {{ translate('device_overlays.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(overlay, index) in overlays" :key="overlay.id || index">
            <td v-for="column in columns" :key="column">
              {{ display_value(overlay, column) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center">
      <button class="btn btn-danger btn-fill btn-wd" @click.prevent="$emit('close')">
        {{ translate('close_modal') }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DeviceOverlays',
  props: {
    overlays: { type: Array, default: () => [] }
  },
  data() {
    return {
      columns: ['id', 'device_id', 'name', 'fw', 'mod_time', 'status', 'created_at', 'updated_at']
    }
  },
  methods: {
    display_value(overlay, column) {
      const value = overlay[column]
      if (value === null || value === undefined || value === '') return '—'
      if (column === 'created_at' || column === 'updated_at') return this.get_date(value)
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.overlays_modal {
  padding: 15px;
  .overlays_table {
    overflow: auto;
    max-height: 60vh;
    margin-bottom: 15px;
  }
  table {
    width: 100%;
    min-width: 900px;
    border-collapse: collapse;
    th, td {
      padding: 6px 8px;
      border: 1px solid #ddd;
      text-align: left;
      font-size: 12px;
      overflow-wrap: anywhere;
    }
  }
}
</style>
